
const { default: axios } = require('axios');
// If you are using CommonJS modules:
const { Dropzone } = require("dropzone");
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling

// If you are using an older version than Dropzone 6.0.0,
// then you need to disabled the autoDiscover behaviour here:
Dropzone.autoDiscover = false;

let myDropzone = new Dropzone("#my-form", {
    url: document.getElementById('my-form').getAttribute('action_url'),
    autoProcessQueue: false,
    maxFilesize: 2, // in MB
    acceptedFiles: '.jpg,.jpeg',
    uploadMultiple: true,
    parallelUploads: 15,
    addRemoveLinks: false,
    accept: function (file, done) {

        // Set your desired image dimensions
        var desiredWidth = 800;  // Example width
        var desiredHeight = 600; // Example height
        // FileReader() asynchronously reads the contents of files (or raw data buffers) stored on the user's computer.
        var reader = new FileReader();
        reader.onload = (function (entry) {
            // The Image() constructor creates a new HTMLImageElement instance.
            var image = new Image();
            image.src = entry.target.result;
            image.onload = function () {

                var width = this.width;
                var height = this.height;

                if (!(width >= desiredWidth && height >= desiredHeight)) {
                    myDropzone.removeFile(file);
                    done("Invalid image dimenssions. Please upload an image with dimensions " + desiredWidth + "x" + desiredHeight + " pixels.");
                }
            };
        });

        reader.readAsDataURL(file);
        done();
    },
    maxFiles: 15,
    init: async function () {
        var myDropzone = this;
        myDropzone.on("processing", function () {
            this.options.autoProcessQueue = true;
        });

        var pid = document.getElementById('my-form').getAttribute('project_id');
        // $('#loading_images').show();
        await axios.get(`/api/map/get-project-images/${pid}`).then(async (res) => {
            let images = res.data.images;
            await images.map(async (item, index) => {
                var mockFile = {
                    id: item.id,
                    name: item.id,
                    size: item.size,
                    status: Dropzone.ADDED,
                    url: item.image_path
                };

                // Call the default addedfile event handler
                await myDropzone.emit("addedfile", mockFile);

                // And optionally show the thumbnail of the file:
                await myDropzone.emit("thumbnail", mockFile, item.image_path);
                await myDropzone.emit("complete", mockFile);

                await myDropzone.files.push(mockFile);
                await ($('#loading_images').hide());
            });

        }).catch(error => {
            if (error.response) {
                // Server responded with a status other than 200 range
                done(error.response.data.message || "Server error");
            } else if (error.request) {
                // Request was made but no response received
                done("Network error");
            } else {
                // Something else caused the error
                done(error.message);
            }
        })

        myDropzone.on("sending", function (file) {
            // Show the total progress bar when uploading starts
            document.querySelector('#uploadButton').innerHTML = "Uploading...";
            document.querySelector('#uploadButton').setAttribute('disabled');
        });

    },
    dictDefaultMessage: `<div class="relative flex items-center justify-center w-full h-64">
            <!-- Removed ID from label -->
            <label class="flex flex-col items-center justify-center w-full h-full border-2 border-gray-300 border-dashed cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg class="mb-4 text-gray-500 w-14 h-14 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                    </svg>
                    <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                        <span class="text-2xl font-semibold">Click to upload or drop files here</span>
                    </p>
                    <p class="px-8 text-center text-red-300 dark:text-gray-400">
                        <ul class="list-disc">
                            <li class="text-xs text-red-300">Minimum 5 or maximum 15 images</li>
                            <li class="text-xs text-red-300">JPEG or JPG format only</li>
                            <li class="text-xs text-red-300">Minimum resolution: 800x600 px</li>
                            <li class="text-xs text-red-300">Maximum image size: 2MB each</li>
                        </ul>
                    </p>
                </div>
            </label>
        </div>`,
    previewTemplate: `<div class="dz-preview dz-error dz-complete dz-image-preview">
        <div class="dz-image"><img data-dz-thumbnail=""  class="w-40 h-40"></div>
        <div class="dz-details">
        <div class="dz-size"><span data-dz-size=""><strong>10.1</strong> MB</span></div>
    </div>
        <div class="dz-progress"> <span class="dz-upload" data-dz-uploadprogress=""></span> </div>
        <div class="dz-error-message"><span data-dz-errormessage=""></span></div>
        <a href="#" class="dz-remove" data-dz-remove><i class="fa fa-times"></i></a>
    </div>`,
    previewsContainer: '#preview',
    dictFallbackMessage: "Your browser does not support drag and drop file uploads.",
    dictFileTooBig: "File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
    dictInvalidFileType: "Invalid file type.",
    dictResponseError: "Server responded with {{statusCode}} code.",
    dictCancelUpload: "Cancel upload",
    dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    dictRemoveFile: "Remove file",
    dictMaxFilesExceeded: "Max files exceeded.",
});
myDropzone.on("addedfile", file => {
    if (myDropzone.files.length > myDropzone.options.maxFiles) {
        myDropzone.removeFile(file);
        myDropzone.emit("maxfilesexceeded", file);
    }

    if (!file?.id) {
        totalImage('add');
    }
});
myDropzone.on("maxfilesexceeded", function (file) {
    var message = "No more files can be added.";
    $('#error_projects_images').text(message).addClass('text-red-400 py-4');
});
myDropzone.on("error", function (file, message) {
    if (message?.errors?.file) {
        message = message.errors.file.toString();
    }
    myDropzone.removeFile(file);
    totalImage();
    $('#error_projects_images').text(message).addClass('text-red-400 py-4');
});
var deletedImage = [];
myDropzone.on("removedfile", file => {
    deletedImage.push(file.id);
    totalImage('remove');
    $('#deleted_images').val(deletedImage.join(','));
})

function totalImage() {
    $('#photos').text(myDropzone.files.length);
}
document.addEventListener('upload:project_floor_plan', (event) => {
    if (event.detail.count) {
        $('#floor_plans_field').val(event.detail.count);
    } else {
        $('#floor_plans_field').val('');

    }
})
document.addEventListener('upload:project_brochure', (event) => {
    
    if (event.detail.count) {
        $('#project_broucher_field').val(event.detail.count);
    } else {
        $('#project_broucher_field').val('');

    }
})

var paymentBreakDown = [];

window.addEventListener('payment_breakdown_payload', (event) => {
    paymentBreakDown = event.detail;
})

if ($('#edit_project').length) {
    const validator = $('#edit_project').validate({
                ignore: "[name='latitude'],[name='longitude']",

        // ignore: [], //forcing to validate hidden field as well
        rules: {
            'amenities[]': {
                required: true, //!$('.checkedBox:checked').length,
                minlength: 4
            },
            price: {
                required: () => {
                    return $('#project_price').prop('required');
                },
            },
            project_pin: {
                required: true,
            },
            latitude: {
                required: true
            },
            longitude: {
                required: true
            },
            project_min_beds: {
                required: function () {
                    return $('#project_min_beds').prop('required'); // if project type is not plot then validate it.
                }
            },
            project_max_beds: {
                required: function () {
                    return $('#project_max_beds').prop('required'); // if project type is not plot then validate it.
                }
            },
            new_description: {
                required: true,
                minlength: 750,
                maxlength: 3000
            },
            sum_plan: {
                required: true,
                min: 100,
                max: 100
            },
           
            post_completion_month: {
                required: function (element) {
                    var val = parseInt($("#post_completion").val());
                    return !isNaN(val) && val > 0;
                },
                min: function (element) {
                    var val = parseInt($("#post_completion").val());
                    return (!isNaN(val) && val > 0) ? 1 : false;
                }
            },
            expected_annual_service_fees:{
                required:true,
                digits:false
            },
            booking_amount_in_percentage:{
                required:true,
            },
            total_floors:{
                required:true,
            },
            total_units:{
                required:true,
            },

            floor_plans: {
                required: true,
            },
            broucher: {
                required: true,
            },

            total_breakdown_percentage: {
                required: true,
                min: 100,
                max: 100
            },
            paymentPlanPercentageField:{
                required:true,
                min:1
            }

        },
        messages: {
            sum_plan: {
                min: 'Sum of payment percentages must total 100%',
                max: 'Sum of payment percentages must total 100%',

            },
            total_breakdown_percentage: {
                required: 'All Fields are required',
                min: 'Sum of payment breakdown must total 100%',
                max: 'Sum of payment breakdown must total 100%',

            },
            price: {
                required: 'This field is required',
            },
            'amenities[]': {
                minlength: 'The amenities must be at least 4 characters.'
            },
            new_description: {
                min: 'The description must be at least 750 characters.'
            },
            project_min_beds: {
                required: 'This field is required',
            },
            project_max_beds: {
                required: 'This field is required',
            },
            floor_plans: {
                required: 'This field is required',
            },
            paymentPlanPercentageField:{
                required:'This field is required',
                min:'This field is required'
            }
        },
        errorPlacement: function (error, element) {
            console.log(error, element,'sadsadsad');
            
            let lat = element.attr("name") == 'latitude' && element.val() == '';
            let project_min_beds = element.attr("name") == 'project_min_beds';
            let amenities = element.attr("name") == 'amenities[]';
            let breakdown = element.attr("name").startsWith('breakdown[');
          
            let project_max_beds = element.attr("name") == 'project_max_beds';
            let floor_plans = element.attr("name") == 'floor_plans';
            let broucher = element.attr("name") == 'broucher';
            let total_breakdown_percentage = element.attr("name") == 'total_breakdown_percentage';
            if (lat) {
                error.appendTo("#lat_long_error");
            } else if (amenities) {
                error.appendTo("#amenities_error");
            } else if (project_min_beds) {
                $("#project_min_beds_error").empty();
                error.appendTo("#project_min_beds_error");
            } else if (breakdown) {
                error.appendTo("#bd-error");
            } else if (project_max_beds) {
                $("#project_max_beds_error").empty();
                error.appendTo("#project_max_beds_error");
            } else if (element.attr('name') == ('project_pin')) {
                error.appendTo("#project_pin_error");
            } else if (element.attr("name") == 'during_construction') {
                error.appendTo("#during_construction-error");
            } else if (element.attr("name") == 'post_completion_month') {
                error.appendTo("#post_completion_month-error");
            } else if (element.attr("name") == 'type') {
                error.appendTo("#type-error");
            } 
            else if (floor_plans) {
                error.appendTo("#floor_plans-error");
            } 
            else if (broucher) {
                error.appendTo("#project_broucher-error");
            } 
            else if (total_breakdown_percentage) {
                error.appendTo("#total_breakdown_percentage-error");
            } else if (element.attr("name") == 'new_description') {
                error.appendTo("#new_description-error").addClass('text-red-500');

            } else if (element.attr("name") == 'permit_number') {
                $("#permit_number-ui-error").addClass('text-red-500').text('This field is required');
            }
            else {
                error.insertAfter(element);
            }
        },
        highlight: function (element) {
            $(element).addClass("border-red-900 shake");

            // Remove class after animation so it can be reused
            setTimeout(() => {
                $(element).removeClass("border-red-900 shake");
            }, 300);
        },
        submitHandler: async (form) => {
            event.preventDefault();
            

            if (myDropzone.files.length > myDropzone.options.maxFiles) {
                $('#photos_error').text('Maximuim 15 images')
                return;
            }
            if (myDropzone.files.length < 5) {
                $('#photos_error').text('Minimum 5 images required')
                return;
            }

            if ($('#permit_number').val() && $('#qrcode_images_count').val() != 1) {
                $('#qrcode_error').text('QR Code required');
                return;
            }
            else {
                $('#qrcode_error').text('');
            }

            if (window.CKEDITOR && CKEDITOR.instances.editor) {
                CKEDITOR.instances.editor.updateElement();
            }

            var formData = $(form).serializeArray();
            formData = formData.filter(function (field) {
                return !field.name.startsWith("breakdown[");
            });

            var formDataObject = {};

            formDataObject['breakdowns'] = paymentBreakDown;



            formData.forEach(function (field) {
                if (field.name.endsWith('[]')) {
                    // Remove the [] from the name to standardize the key
                    var key = field.name.slice(0, -2);
                    if (!formDataObject[key]) {
                        formDataObject[key] = [];
                    }
                    formDataObject[key].push(field.value);
                } else {
                    formDataObject[field.name] = field.value;
                }
            });
            if (myDropzone.getQueuedFiles().length > 0) {
                await myDropzone.processQueue(); // Manually start the upload process
                await myDropzone.on("successmultiple", async () => {
                    document.querySelector('#uploadButton').innerHTML = "Save";
                    document.querySelector('#uploadButton').removeAttribute('disabled');
                    // Hide the total progress bar when all uploads are completed
                    await saveData(form, formDataObject);
                })
                await myDropzone.on("error", async (file, message) => {
                    if (message && typeof message === 'object' && 'message' in message) {
                        $('#photos_error').text(message.message);
                        document.querySelector('#uploadButton').innerHTML = "Save";
                        document.querySelector('#uploadButton').removeAttribute('disabled');
                    }

                })
            } else {
                await saveData(form, formDataObject);
            }

            function saveData(form, formDataObject) {
                document.querySelector('#uploadButton').innerHTML = "Saving...";
                document.querySelector('#uploadButton').setAttribute('disabled');

                axios.post($(form).attr('action'), formDataObject, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                }).then((res) => {                    
                    Livewire.emit('alert', { 'message': res.data.message, 'type': 'success', 'html': false })
                    window.location.href = res.data.redirect;
                }).catch(error => {
                    if (error.status === 422) {
                        let serverErrors = error.response.data.errors;
                        let formattedErrors = {};

                        Object.keys(serverErrors).forEach(function (field) {
                            // jQuery Validate only accepts a single message
                            formattedErrors[field] = serverErrors[field][0];
                        });
                        console.log(formattedErrors);

                        // Display errors using jQuery Validation
                        validator.showErrors(formattedErrors);
                    }
                    console.log(error);
                }).finally(() => {
                    document.querySelector('#uploadButton').innerHTML = "Save";
                    document.querySelector('#uploadButton').removeAttribute('disabled');
                })
            }
            return false;
        }
    });
}
